export default class ServiceProvider {
    constructor(groupService, activityService, individualFormService) {
        this._groupService = groupService;
        this._activityService = activityService;
        this._individualFormService = individualFormService;
    }
    get groupService() {
        return this._groupService;
    }
    get activityService() {
        return this._activityService;
    }
    get individualFormService() {
        return this._individualFormService;
    }
}
